
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title ,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            }
          ],
        }
      },
    
      components: {
      },
      data() {
        return {
          title: 'Ganpati Pujan Sahitya | Pujan Sahitya -  गणपती पूजन साहित्य ( पूजन साहित्य )',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
  
  
  
      computed: {
  
      },
      methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
  
    }
  